var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M0.666992 10.0001H2.33366V17.5001H0.666992V10.0001ZM3.16699 11.6667H4.83366V17.5001H3.16699V11.6667ZM12.3337 6.66675H14.0003V17.5001H12.3337V6.66675ZM14.8337 8.33342H16.5003V17.5001H14.8337V8.33342ZM6.50033 1.66675H8.16699V17.5001H6.50033V1.66675ZM9.00032 3.33342H10.667V17.5001H9.00032V3.33342Z","fill":"current-color"}})
}
var staticRenderFns = []

export { render, staticRenderFns }